module.exports = __webpack_public_path__ + "static/media/pointing_arrow_bottom.e6ebf839.png";